/**
 * @desc getStockOrder
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockOrder.getStockOrder.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/order`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
